import { useFeatureFlag } from '~/composables/useFeatureFlag'

export default defineNuxtRouteMiddleware((to) => {
  // TODO delete file when removing featureFlag ssoLogin
  if (useFeatureFlag('ssoLogin')) {
    return
  }

  const { isLoggedIn } = useUserStore()

  if (isLoggedIn) {
    return
  }

  return navigateTo({ name: 'login', query: { next: to.fullPath } })
})
